/** 已请求终止的图片裁剪任务 ID（列表 / 详情 / 创建流程共用） */
const cancelledTaskIds = new Set();

const CREATE_ABORT_MAP = new Map();

export function isImageCropTaskCancelled(taskId) {
  if (taskId == null) return false;
  return cancelledTaskIds.has(String(taskId));
}

/** 任务库状态是否表示用户已终止（含刷新后内存 cancel 标记丢失） */
export function isImageCropTerminatedStatus(status) {
  const s = String(status || '').toLowerCase();
  return s === 'partial' || s === 'canceled' || s === 'cancelled';
}

export function shouldStopImageCropTask(taskId, taskStatus, taskResult) {
  if (isImageCropTaskCancelled(taskId)) return true;
  if (isImageCropTerminatedStatus(taskStatus)) return true;
  if (String(taskResult?.batchPhase || '').toLowerCase() === 'cancelled') return true;
  return false;
}

export function registerImageCropCreateAbort(taskId, abortController) {
  if (taskId == null || !abortController) return;
  CREATE_ABORT_MAP.set(String(taskId), abortController);
}

export function unregisterImageCropCreateAbort(taskId) {
  if (taskId == null) return;
  CREATE_ABORT_MAP.delete(String(taskId));
}

/** 终止任务：标记取消、中断创建流程中的请求，并通知详情页停止 */
export function cancelImageCropTask(taskId) {
  if (taskId == null) return;
  const key = String(taskId);
  cancelledTaskIds.add(key);
  const ac = CREATE_ABORT_MAP.get(key);
  if (ac) {
    try {
      ac.abort();
    } catch {
      /* ignore */
    }
    CREATE_ABORT_MAP.delete(key);
  }
  window.dispatchEvent(
    new CustomEvent('imageCropTaskCancel', { detail: { taskId: key } }),
  );
}

/** 用户主动重试/重新裁剪时清除终止标记，允许同会话内再次处理 */
export function clearImageCropTaskCancelled(taskId) {
  if (taskId == null) return;
  cancelledTaskIds.delete(String(taskId));
}
